const HCategoryData = [
    {
        id: 1,
        slug: "psychology",
        cover: require("../../Assets/Category/PSYCHOLOGY.jpg"),
        title: "PSYCHOLOGY ",
        description: "Psychology explores behavior and mental processes, aiming to understand and improve mental health and well-being.",

        brands: [
            {
                id: 1,
                cover: require("../../Assets/Brands/1.png")
            },
            {
                id: 2,
                cover: require("../../Assets/Brands/2.png")
            },
            {
                id: 3,
                cover: require("../../Assets/Brands/thoughttec-brand.png")
            },
            {
                id: 4,
                cover: require("../../Assets/Brands/3.png")
            },
        ]
    },
    {
        id: 2,
        slug: "biomechanics",
        cover: require("../../Assets/Category/BIOMECHANICS.jpg"),
        title: "BIOMECHANICS ",
        description: "Biomechanics studies the mechanical aspects of living organisms to understand movement and improve function.",
        brands: [
            {
                id: 1,
                cover: require("../../Assets/Brands/Qualisys-Logo.jpg")
            },
            {
                id: 2,
                cover: require("../../Assets/Brands/Delsyslogo.png")
            },
            {
                id: 3,
                cover: require("../../Assets/Brands/berteclogo.png")
            },
            {
                id: 4,
                cover: require("../../Assets/Brands/moxy-logo.webp")
            },
        ]
    },
    {
        id: 3,
        slug: "physiology",
        cover: require("../../Assets/Category/PHYSIOLOGY.jpg"),
        title: "PHYSIOLOGY",
        description: "Physiology studies the functions and processes of living organisms to understand how they work.",

        brands: [
              {
                id: 1,
                 cover: require("../../Assets/Brands/berteclogo.png")
            },
            
            {
                id: 2,
                cover: require("../../Assets/Brands/Delsyslogo.png")
            },
            {
                id: 3,
                cover: require("../../Assets/Brands/meslogo.gif")
            },
            {
                id: 4,
                cover: require("../../Assets/Brands/moxy-logo.webp")
            },
        ]
    },
    {
        id: 4,
        slug: "ergonomics",
        cover: require("../../Assets/Category/ERGONOMICS.jpeg"),
        title: "ERGONOMICS",
        description: "Ergonomics designs and optimizes work environments to improve comfort, efficiency, and safety.",
        brands: [
            {
                id: 1,
                cover: require("../../Assets/Brands/nexgenlogo.png")
            },
            {
                id: 2,
                cover: require("../../Assets/Brands/Qualisys-Logo.jpg")
            },
            {
                id: 3,
                cover: require("../../Assets/Brands/thoughttec-brand.png")
            },
            {
                id: 4,
                cover: require("../../Assets/Brands/Ergoneerslogo.png")
            },
        ]
    },

    {
        id: 5,
        slug: "strength-and-conditioning",
        cover: require("../../Assets/Category/SCIENTIFIC GYM.jpeg"),
        title: "SCIENTIFIC GYM",
        description: "Scientific Gym uses evidence-based methods and technology to optimize workouts and enhance fitness results.",
        brands: [
            {
                id: 1,
                cover: require("../../Assets/Brands/FTT-Logo.png")
            },
            {
                id: 2,
                cover: require("../../Assets/Brands/moxy-logo.webp")
            },
            {
                id: 3,
                cover: require("../../Assets/Brands/berteclogo.png")
            },
            {
                id: 4,
                cover: require("../../Assets/Brands/hasomedlogo.png")
            },
        ]
    },
    {
        id: 6,
        slug: "sports-science",
        cover: require("../../Assets/Category/SPORTS SCIENCE.jpg"),
        title: "SPORTS SCIENCE",
        description: "Sports Science applies scientific principles to enhance athletic performance, training, and recovery.",
        brands: [
            {
                id: 1,
                cover: require("../../Assets/Brands/FTT-Logo.png")
            },
            {
                id: 2,
                cover: require("../../Assets/Brands/catapult.jpg")
            },
            {
                id: 3,
                cover: require("../../Assets/Brands/berteclogo.png")
            },
            {
                id: 4,
                cover: require("../../Assets/Brands/goodpl.png")
            },
        ]
    },
]

export default HCategoryData;